<div class="d-flex flex-column align-items-center px-4 py-3 mx-auto card-container">
  <div class="d-flex card-media">
    <div class="d-flex canavs-totalsales">
      <div class="d-flex flex-column w-100 text-wrapper">
        <p class="font-weight-bolder first-header">Gross sales</p>
        <p class="font-weight-bolder second-header">{{ dashboardData?.gross_sales ? (dashboardData?.gross_sales | number) : 0 }} {{ currencySlug | uppercase }}</p>
        <p class="third-header">Total sales</p>
      </div>
      <div class="canavas-commission-container d-flex align-items-center flex-column">
        <div>
          <canvas #grossSales></canvas>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center w-100 commission-legend">
      <div id="legend-container" class="w-100 align-self-start legend-container">
        <ul>
          <li><span class="legend-bullet"></span> Net profit: {{ netProfit ? (netProfit | number) : 0 }} {{ currencySlug | uppercase }}</li>
          <li><span class="legend-bullet"></span> Processing fees: {{ processingFees ? (processingFees | number) : 0 }} {{ currencySlug | uppercase }}</li>
        </ul>
      </div>
      <div class="commission-percentage-container">
        <div class="d-flex">
          <ng-container *ngIf="isAdmin; else displayAsText">
            <input class="commission-percentage" type="number" [formControl]="commission" (blur)="updateCommissionValue($event.target.value)" />
            <span class="align-self-center">%</span>
          </ng-container>
          <ng-template #displayAsText>
            <span>{{ dashboardData?.commission ? dashboardData.commission : 0 }}%</span>
          </ng-template>
        </div>

        <span>+</span>

        <div class="input-group commission-display">
          <ng-container *ngIf="isAdmin; else displayExtraAsText">
            <input type="number" class="extra-commission-percentage" [formControl]="extraCommission" (blur)="updateExtraCommissionValue($event.target.value)" />
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">{{ currencySlug | uppercase }}</span>
            </div>
          </ng-container>
          <ng-template #displayExtraAsText>
            <span>{{ dashboardData?.extra_commission_amount ? dashboardData.extra_commission_amount + ' ' + (currencySlug | uppercase) : '0 ' + (currencySlug | uppercase) }}</span>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
